export default "__VITE_ASSET__DQ6LbI1y__"